/**
 * Імена риб і прикмети виду: українська.
 *
 * ⚠️ ПЕРЕКЛАД, А НЕ ПЕРЕПИС РОСІЙСЬКОГО. У більшості видів є питома українська
 * назва — «краснопірка», «в'язь», «клень», «марена», «пічкур», — і саме її
 * шукає гравець у визначнику. Калька з російської тут гірша за помилку: вона
 * виглядає правильною.
 *
 * Про склад файлу і про те, чому тут немає латини, — див. species-north-ru.ts.
 */
export const РЫБЫ_UK: Record<string, string> = {
  // ── коропові ────────────────────────────────────────────────────────────
  'fish.bream': 'лящ',
  'fish.bream_look':
    'Високий, плаский як долоня, темно-бронзовий. Стоїть зграєю на мулистих плесах і на виході з ям.',
  'fish.silver_bream': 'плоскирка',
  'fish.silver_bream_look':
    'Схожа на підлящика, але плавці з червонню, а луска більша. Тримається біля самого дна.',
  'fish.blue_bream': 'синець',
  'fish.blue_bream_look':
    'Вузький і високий, зі синюватою спиною й довгим анальним плавцем. Ходить у товщі води.',
  'fish.white_bream': 'клепець',
  'fish.white_bream_look':
    'Сріблястий, з великим каламутно-білим оком і тупим рилом. Любить течію на піску.',
  'fish.carp': 'короп',
  'fish.carp_look':
    'Товстий, золотаво-бурий, з двома парами вусів. Риє дно на мілкому, видаючи себе каламуттю.',
  'fish.wild_carp': 'сазан',
  'fish.wild_carp_look':
    'Дикий короп: прогонистіший, темніший і злішій. Тримається в корчах і біля стіни очерету.',
  'fish.crucian': 'карась',
  'fish.crucian_look': 'Круглий, золотавий, без вусів. Стоїть у трав’яних затоках і замулених ставках.',
  'fish.gibel_carp': 'карась сріблястий',
  'fish.gibel_carp_look':
    'Сріблястий, пласкіший за золотого, спинний плавець із зазубнем. Живе всюди, де є вода.',
  'fish.roach': 'плітка',
  'fish.roach_look': 'Срібляста, з червоним оком і жовтогарячими плавцями. Стоїть зграйкою біля трави.',
  'fish.kutum': 'кутум',
  'fish.kutum_look':
    'Велика темна плітка каспійських річок, з товстими губами. Годується скойкою на косах.',
  'fish.rudd': 'краснопірка',
  'fish.rudd_look':
    'Золотава, з яскраво-червоними плавцями й задертим ротом. Годується біля поверхні над травою.',
  'fish.ide': 'в’язь',
  'fish.ide_look':
    'Товстий, світло-бронзовий, з малиновими плавцями. Стоїть на межі течії й тиші.',
  'fish.chub': 'клень',
  'fish.chub_look':
    'Широколобий, з великою темною лускою і червоним хвостом. Тримається під навислими кущами.',
  'fish.dace': 'ялець',
  'fish.dace_look': 'Дрібний, сріблястий, з вузьким тілом і прямим ротом. Стоїть на піщаних перекатах.',
  'fish.tench': 'лин',
  'fish.tench_look':
    'Темно-зелений, у слизу, з крихітними вусиками й червоним оком. Порпається в твані біля очерету.',
  'fish.nase': 'підуст',
  'fish.nase_look': 'Темна спина, нижній поперечний рот, чорна очеревина. Шкребе каміння на бистрині.',
  'fish.barbel': 'марена',
  'fish.barbel_look':
    'Прогонисте тіло, чотири вуси, нижній рот. Лежить на дні швидких кам’янистих ділянок.',
  'fish.dnieper_barbel': 'марена дніпровська',
  'fish.dnieper_barbel_look':
    'Марена дніпровських порогів, темніша й коротша за звичайну. Тримається за камінням на струмені.',
  'fish.grass_carp': 'білий амур',
  'fish.grass_carp_look':
    'Довгий, валькуватий, з широким лобом. Пасеться в заростях, зрізаючи молодий очерет.',
  'fish.black_carp': 'чорний амур',
  'fish.black_carp_look':
    'Темний, майже чавунний, з потужними глотковими зубами. Трощить скойку на дні.',
  'fish.silver_carp': 'білий товстолоб',
  'fish.silver_carp_look':
    'Сріблястий, лоб широкий, очі посаджені низько. Ходить у товщі й вистрибує від шуму.',
  'fish.bighead_carp': 'строкатий товстолоб',
  'fish.bighead_carp_look':
    'Більший за білого, у темних плямах, голова величезна. Тримається в товщі над ямами.',
  'fish.vimba': 'сирть',
  'fish.vimba_look': 'Прогониста, з горбатим носом і темною спиною. Іде зграєю вгору за течією.',
  'fish.sabrefish': 'чехоня',
  'fish.sabrefish_look':
    'Пласка шабля: спина пряма, черево вигнуте, рот верхній. Б’є малька в товщі на струмені.',
  'fish.shemaya': 'шемая',
  'fish.shemaya_look': 'Вузька срібляста рибка з темною спинкою. Годується біля поверхні на течії.',
  'fish.bleak': 'верховодка',
  'fish.bleak_look': 'Дрібна, яскраво-срібляста, рот верхній. Товчеться біля поверхні всією зграєю.',
  'fish.moderlieschen': 'вівсянка',
  'fish.moderlieschen_look':
    'Крихітна, прозоро-срібляста. Живе біля самої поверхні стоячих ставків.',
  'fish.gudgeon': 'пічкур',
  'fish.gudgeon_look': 'Плямистий, з двома вусиками й пласким черевцем. Лежить на піску біля перекату.',
  'fish.schneider': 'бистрянка',
  'fish.schneider_look':
    'Схожа на верховодку, але вздовж боку йдуть дві темні смужки. Тримається на швидкій воді.',
  'fish.amur_bream': 'амурський лящ',
  'fish.amur_bream_look':
    'Лящ Амуру: вужчий за нашого, з прямою спиною й дрібною лускою. Ходить зграєю протоками.',
  'fish.volga_nase': 'волзький підуст',
  'fish.volga_nase_look':
    'Підуст волзьких приток, світліший за дніпровського. Шкребе каміння на перекатах.',
  'fish.bitterling': 'гірчак',
  'fish.bitterling_look':
    'Крихітний, високий, з райдужною смугою вздовж боку. Живе там, де є скойки-беззубки.',
  'fish.amur_chebak': 'амурський чебак',
  'fish.amur_chebak_look':
    'Амурська плітка: срібляста, зі спиною в темінь. Стоїть зграєю в тихих протоках.',
  'fish.skygazer': 'верхогляд',
  'fish.skygazer_look': 'Хижак із задертим угору ротом і високою спиною. Б’є малька в товщі Амуру.',
  'fish.yellowcheek': 'жовтощок',
  'fish.yellowcheek_look':
    'Великий амурський хижак із жовтою плямою на щоці. Ганяє зграї на бистрині.',
  'fish.asp': 'білизна',
  'fish.asp_look':
    'Прогониста, срібляста, з випнутою нижньою щелепою. Б’є малька на поверхні.',

  // ── лососеві ────────────────────────────────────────────────────────────
  'fish.brown_trout': 'струмкова форель',
  'fish.brown_trout_look':
    'Плямиста, з червоними цятками у світлих обідках. Стоїть у холодних струмках за камінням.',
  'fish.lake_trout': 'озерна форель',
  'fish.lake_trout_look':
    'Велика срібляста форель глибоких озер, плями темні. Виходить на мілини надвечір.',
  'fish.rainbow_trout': 'райдужна форель',
  'fish.rainbow_trout_look':
    'Срібляста, з рожевою смугою вздовж боку й чорним крапом. Тримається в товщі.',
  'fish.sea_trout': 'кумжа',
  'fish.sea_trout_look':
    'Прохідна форель: у річці темнішає, вкривається бурими плямами. Іде вгору на нерест.',
  'fish.salmon': 'сьомга',
  'fish.salmon_look':
    'Потужна, срібляста, з чорними хрестиками вище бічної лінії. Стоїть у ямах на шляху нересту.',
  'fish.arctic_char': 'арктичний голець',
  'fish.arctic_char_look':
    'Темна спина, світлі плями без обідків, черево від рожевого до багряного. Любить крижану воду.',
  'fish.palia': 'палія',
  'fish.palia_look': 'Голець глибоких північних озер: темний, з білою облямівкою нижніх плавців.',
  'fish.taimen': 'таймень',
  'fish.taimen_look':
    'Величезний річковий лосось із пласкою головою й червоним хвостом. Господар сибірських річок.',
  'fish.danube_salmon': 'дунайський лосось',
  'fish.danube_salmon_look':
    'Таймень Дунаю: мідно-бурий, у дрібному крапі, хвіст широкий. Стоїть у глибоких плесах.',
  'fish.marble_trout': 'мармурова форель',
  'fish.marble_trout_look':
    'Велика форель балканських річок: бік у мармурових розводах, червоних цяток немає.',
  'fish.lenok': 'ленок',
  'fish.lenok_look': 'Темний, з дрібним крапом і тупим рилом. Стоїть на перекатах сибірських річок.',
  'fish.sevan_trout': 'севанська форель',
  'fish.sevan_trout_look':
    'Форель Севану: срібляста, з поодинокими темними плямами. Тримається на глибині озера.',

  // ── сигові ──────────────────────────────────────────────────────────────
  'fish.whitefish': 'сиг',
  'fish.whitefish_look':
    'Сріблястий, з нижнім ротом і щільною дрібною лускою. Ходить зграєю біля дна холодних озер.',
  'fish.vendace': 'ряпушка',
  'fish.vendace_look': 'Дрібний сиг із верхнім ротом і синюватою спиною. Тримається зграями в товщі.',
  'fish.peled': 'пелядь',
  'fish.peled_look': 'Високотілий сиг із темною головою й кінцевим ротом. Збирає рачка в товщі.',
  'fish.omul': 'омуль',
  'fish.omul_look': 'Байкальський сиг: прогонистий, великоокий. Ходить зграями слідом за рачком.',
  'fish.broad_whitefish': 'чир',
  'fish.broad_whitefish_look':
    'Горбатий сиг північних річок, з товстою мордою й нижнім ротом. Годується на дні.',
  'fish.muksun': 'муксун',
  'fish.muksun_look': 'Сиг сибірських річок: срібний, з гострим рилом. Тримається в придонній товщі.',
  'fish.nelma': 'нельма',
  'fish.nelma_look':
    'Білий лосось сигових кровей: великий, з широким ротом. Ганяє малька в річках Півночі.',
  'fish.grayling': 'харіус',
  'fish.grayling_look':
    'Темна спина і величезний вітрильний плавець у плямах. Стоїть за камінням на струмені.',
  'fish.siberian_grayling': 'сибірський харіус',
  'fish.siberian_grayling_look':
    'Більший за європейського, вітрило яскравіше й з червоною облямівкою. Тримається на бистринах.',

  // ── окуневі ─────────────────────────────────────────────────────────────
  'fish.perch': 'окунь',
  'fish.perch_look':
    'Смугастий, з колючим спинним плавцем і червоними черевними. Тримається зграйкою.',
  'fish.zander': 'судак',
  'fish.zander_look': 'Сріблясто-сірий, з іклами й колючим гребенем. Ходить дном, біля брівок і ям.',
  'fish.volga_zander': 'берш',
  'fish.volga_zander_look':
    'Схожий на судака, але дрібніший, без іклів і з тупою мордою. Стоїть на піщаних ямах.',
  'fish.ruffe': 'йорж',
  'fish.ruffe_look': 'Колючий, сіро-бурий у темних цятках, увесь у слизу. Лежить на дні в глибині.',
  'fish.donets_ruffe': 'носар',
  'fish.donets_ruffe_look':
    'Йорж із видовженим рилом і жовтуватим забарвленням. Тримається на піску річкових струменів.',
  'fish.zingel': 'чоп',
  'fish.zingel_look':
    'Довгий, валькуватий, у темних перев’язях, з двома спинними плавцями. Притиснутий до дна.',
  'fish.streber': 'чоп малий',
  'fish.streber_look': 'Тонший і дрібніший за чопа, плями на боці помітніші. Живе на кам’янистих струменях.',
  'fish.percarina': 'перкарина',
  'fish.percarina_look':
    'Крихітний напівпрозорий окунець лиманів, очі великі. Ходить зграйками в товщі.',

  // ── осетрові ────────────────────────────────────────────────────────────
  'fish.sterlet': 'стерлядь',
  'fish.sterlet_look':
    'Дрібний осетер із вузьким гострим рилом і торочкуватими вусиками. Ходить дном на течії.',
  'fish.russian_sturgeon': 'російський осетер',
  'fish.russian_sturgeon_look':
    'Тупорилий осетер із рядами кістяних жучок уздовж спини. Годується на дні ям.',
  'fish.siberian_sturgeon': 'сибірський осетер',
  'fish.siberian_sturgeon_look':
    'Осетер сибірських річок: темніший за російського, рило коротше. Тримається біля самого ґрунту.',
  'fish.stellate_sturgeon': 'севрюга',
  'fish.stellate_sturgeon_look':
    'Осетер із довгим мечоподібним рилом і вузьким тілом. Риється в піску на глибині.',
  'fish.beluga': 'білуга',
  'fish.beluga_look':
    'Найбільша риба прісних вод: величезна паща, тупе рило. Стоїть у глибоких ямах.',
  'fish.ship_sturgeon': 'шип',
  'fish.ship_sturgeon_look': 'Осетер із суцільною нижньою губою — на вигляд між севрюгою та осетром.',
  'fish.kaluga': 'калуга',
  'fish.kaluga_look': 'Білуга Амуру: велетень із широкою пащею. Тримається на дні великих плес.',
  'fish.paddlefish': 'веслоніс',
  'fish.paddlefish_look':
    'Осетровий із довгим веслом замість рила. Проціджує рачка, ідучи в товщі з відкритим ротом.',

  // ── сомові ──────────────────────────────────────────────────────────────
  'fish.catfish': 'сом',
  'fish.catfish_look':
    'Голе темне тіло, широка паща, два довгі вуси. Лежить у ямах і під завалами.',
  'fish.channel_catfish': 'канальний сомик',
  'fish.channel_catfish_look':
    'Плямистий, з вилчастим хвостом і чотирма парами вусів. Ходить дном зграєю.',
  'fish.amur_catfish': 'косатка-скрипун',
  'fish.amur_catfish_look': 'Невеликий сомик із жовтими смугами й колючими шипами. У руці скрипить.',
  'fish.clarias': 'кларіас',
  'fish.clarias_look':
    'Вугруватий сом із довгим спинним плавцем, дихає повітрям. Тримається в теплій каламутній воді.',

  // ── щукові ──────────────────────────────────────────────────────────────
  'fish.pike': 'щука',
  'fish.pike_look':
    'Видовжена, темно-зелена з жовтими плямами, паща в зубах. Стоїть у засідці біля трави й корчів.',
  'fish.amur_pike': 'амурська щука',
  'fish.amur_pike_look':
    'Щука Амуру: срібляста, у дрібному темному крапі замість жовтих плям. Стоїть у протоках.',

  // ── центрархові ─────────────────────────────────────────────────────────
  'fish.pumpkinseed': 'сонячний окунь',
  'fish.pumpkinseed_look':
    'Строкатий, круглий, з жовтогарячою плямою на зябровій кришці. Товчеться біля трави.',
  'fish.largemouth_bass': 'великоротий окунь',
  'fish.largemouth_bass_look':
    'Зелений, з темною смугою вздовж боку й пащею до ока. Стоїть у корчах.',
  'fish.smallmouth_bass': 'малоротий окунь',
  'fish.smallmouth_bass_look':
    'Бронзовий, з темними перев’язями впоперек боку. Любить кам’янисте дно й струмінь.',

  // ── бичкові ─────────────────────────────────────────────────────────────
  'fish.round_goby': 'бичок-кругляк',
  'fish.round_goby_look':
    'Темний, з чорною плямою на спинному плавці; черевні зрослися в присоску. Сидить на дні.',
  'fish.sand_goby': 'бичок-пісочник',
  'fish.sand_goby_look': 'Світлий, піщаного кольору, бік у цятках. Тримається на піщаних мілинах.',
  'fish.tubenose_goby': 'бичок-цуцик',
  'fish.tubenose_goby_look':
    'Крихітний, з трубочками ніздрів, що стирчать над верхньою губою. Живе серед каміння.',

  // ── в’юнові ──────────────────────────────────────────────────────────────
  'fish.weatherfish': 'в’юн',
  'fish.weatherfish_look':
    'Довгий, змієподібний, у темних смугах, з десятьма вусиками. Дихає повітрям у затхлій воді.',
  'fish.spined_loach': 'щипавка',
  'fish.spined_loach_look':
    'Вузька, з рядом темних плям і складаним шипом під оком. Заривається в пісок.',
  'fish.stone_loach': 'слиж',
  'fish.stone_loach_look': 'Гладкий, плямистий, із шістьма вусиками. Ховається під камінням у струмках.',

  // ── корюшкові ───────────────────────────────────────────────────────────
  'fish.smelt': 'корюшка',
  'fish.smelt_look':
    'Прозоро-срібляста, у роті дрібні зуби, пахне свіжим огірком. Ходить щільною зграєю.',
  'fish.snetok': 'снеток',
  'fish.snetok_look': 'Дрібна озерна корюшка завдовжки з палець. Тримається зграями в холодній товщі.',

  // ── міногові ────────────────────────────────────────────────────────────
  'fish.river_lamprey': 'річкова мінога',
  'fish.river_lamprey_look':
    'Зовсім не риба: змієподібна, без щелеп, з круглою присоскою замість рота.',
  'fish.ukrainian_lamprey': 'українська мінога',
  'fish.ukrainian_lamprey_look':
    'Дрібна мінога струмків: дорослою не годується зовсім. Личинки роками живуть у мулі.',

  // ── інші ────────────────────────────────────────────────────────────────
  'fish.rotan': 'ротань',
  'fish.rotan_look':
    'Темний, головатий, з великим ротом. Захоплює дрібні ставки й виїдає в них усе живе.',
  'fish.snakehead': 'зміноголов',
  'fish.snakehead_look':
    'Зміїна голова в щитках, довгий спинний плавець. Дихає повітрям і стереже свій виводок.',
  'fish.burbot': 'минь',
  'fish.burbot_look':
    'Єдина прісноводна тріска: слизький, плямистий, з вусиком на підборідді. Оживає в холод.',
  'fish.eel': 'вугор',
  'fish.eel_look':
    'Змієподібний, слизький, з крихітними зябровими щілинами. Уночі виходить на мілини, удень у мулі.',
  'fish.bullhead': 'бабець',
  'fish.bullhead_look':
    'Головатий, приплюснутий, у розводах, без луски. Сидить під камінням чистих струмків.',
  'fish.bigmouth_buffalo': 'великоротий буфало',
  'fish.bigmouth_buffalo_look':
    'Схожий на великого карася з товстою спиною, рот спрямований уперед. Годується в товщі.',
  'fish.smallmouth_buffalo': 'малоротий буфало',
  'fish.smallmouth_buffalo_look': 'Темніший за великоротого, рот нижній. Збирає корм просто з дна.',
  'fish.tilapia': 'тиляпія',
  'fish.tilapia_look':
    'Високотіла, у поперечних смугах, з довгим спинним плавцем. Любить теплу воду.',
};
